import React, { useState, createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import RouteConstant from "../../../constants/routesContent.json";
import LoginConstants from "../../../constants/contentFile.json";
import { validateOtp, validateRegesterdMobileNumber } from "../../../utils/service";
import { useCookies } from "react-cookie";
import { getMobileLink, postMobileOTP } from "../../../apis/Api";

export const MobileOtpContext = createContext({});
export const MobileOtpContextProvider = ({ children }) => {
  const [otp, setOtp] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const loginContent = LoginConstants.errorMessages;
  const [cookies, setCookie] = useCookies(["user"]);
  const [otpTimeOut, setOtpTimeOut] = useState(0);
  const [successOTPMessage, setSuccessOTPMessage] = useState("");
  const [otpStatusCode, setOtpStatusCode] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  const [timer, setTimer] = useState(0);
  const [showResend, setShowResend] = useState(false);
  const [showGetOtp, setShowGetOtp] = useState(true);
  const [isOtpValid, setIsOtpValid] = useState(false)

  useEffect(() => {
    let countdown;
    if (timer > 0) {
      setShowGetOtp(false);
      setShowResend(false);
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0 && !showGetOtp) {
      setShowResend(true);
    }
    return () => clearInterval(countdown);
  }, [timer]);

  const handleGetOTP = () => {
    getDriverOTP();
    setTimer(60); // Set 30-second timer
  };

  const handleResendOTP = () => {
    getDriverOTP();
    setTimer(60); // Reset timer
    setShowResend(false);
  };

  const getDriverOTP = async () => {
    try {
      const getOtpData = await getMobileLink();
      if (getOtpData?.data?.statusCode == 200) {
        setOtpStatusCode(getOtpData?.data?.statusCode);
        setSuccessOTPMessage(getOtpData?.data?.statusMessage);
        setShowAlert(false);
        setOtp(getOtpData?.data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 400) {
        const errorMessage = error.response.data.statusMessage;
        setShowAlert(true);
        setAlertMessage(errorMessage)
      } else {
        setAlertMessage(loginContent.somethingWrong);
        setShowAlert(true);
      }
    }
  };

  const path = window.location.href; // Get full URL

  const match = path.match(/token\/([^/]+)/); // Extract token after 'token/'

  const ShareToken = match ? match[1] : null;
  setCookie("Share-Token", ShareToken, { path: "/" });

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (otp === "") {
      setIsOtpValid(false);
    } else if (!/^\d{6}$/.test(otp)) {
      setIsOtpValid(false);
    } else {
      setIsOtpValid(true);
    }
  }, [otp]);

  const onSubmitOTP = async () => {
    const otpData = {
      otp: otp,
    };
    try {
      const getOtpData = await postMobileOTP(otpData);
      if (getOtpData?.data?.statusCode == 200) {
        const accessToken = getOtpData?.data?.access_token;
        setCookie("xAccessToken", accessToken, { path: "/" });
        const gateStatus = getOtpData?.data?.share_status;
        const targetRoute =
          gateStatus == "Gate-In"
            ? RouteConstant?.GATE_OUT
            : RouteConstant?.GATE_IN;
        navigate(targetRoute);
      }
    } catch (error) {
      if (error?.response?.data?.statusCode === 400) {
        const errorMessage = error.response.data.statusMessage;
        const otpExpiryStatus = true;
        setShowAlert(true);
        setAlertMessage(errorMessage)
        // navigate(RouteConstant.LINK_EXPIRED, { state: {errorMessage,  otpExpiryStatus}});
      } else {
        setAlertMessage(loginContent.somethingWrong);
        setShowAlert(true);
      }
    }
  };

  const handleOTPChange = (otpValue) => {
    // Allow only numeric input (prevent letters or special characters)
    const numericOtp = otpValue.replace(/\D/g, "");

    // Ensure OTP is exactly 6 digits
    if (numericOtp.length <= 6) {
      setOtp(numericOtp);
    }
  };

  const providerValue = {
    otp,
    goBack,
    showAlert,
    setShowAlert,
    alertMessage,
    setAlertMessage,
    otpTimeOut,
    getDriverOTP,
    onSubmitOTP,
    handleOTPChange,
    showGetOtp,
    handleGetOTP,
    timer,
    showResend,
    handleResendOTP,
    successOTPMessage,
    otpStatusCode,
    isOtpValid,
    setOtp
  };

  return (
    <MobileOtpContext.Provider value={providerValue}>
      {children}
    </MobileOtpContext.Provider>
  );
};
